//Customer Settings object is being constructed here.
//Called from server-rendering.js where it is injected in a <script></script>
import Global from '../../global';
import KambiRoutesConfig from './kambi-routes-config';

export default function(settingsJson, callbackFunctions, brand) {
  const {
    heartBeatCallback,
    keepAliveCallback,
    kickUserCallback,
    notificationsCallback,
    showEventStatisticsCallback
  } = callbackFunctions;

  let CustomerSettings = function() {
    let self = this;
    for (var property in settingsJson) {
      if (settingsJson.hasOwnProperty(property))
        self[property] = settingsJson[property];
    }

    // existing routes where kambi renders an empty div
    (this.emptyClientRoutes = KambiRoutesConfig.getEmptyClientRoutes(brand)),
      // usually when a route does not exist in Kambi there will be a redirect to /home
      // reservedRoutes are routes that don't exist in Kambi,
      // but SportClient has content for them and the redirect should not happen
      // WHEN ADDIND A NEW RESERVED ROUTE - the route should be added in emptyClientRoutes as well
      // in order for kambi to render an empty div
      (this.reservedRoutes = KambiRoutesConfig.getReservedRoutes(brand));
  };

  CustomerSettings.prototype.notification = function(event) {
    //Global.logger().debug("[CustomerSettings] notification", JSON.stringify(event));
    notificationsCallback(event);
  };
  /** * Inform the operator that the current user should be logged out.
   *
   * It is the responsibility of the operator to make sure that the user is
   * logged out and that the HTML page is reloaded afterwards.
   *
   * @param {Function} $ Reference to jQuery library, loaded internally
   */
  CustomerSettings.prototype.logout = function($) {
    Global.logger.debug('[CustomerSettings] logout', $);
    kickUserCallback();
  };
  /**
   * Inform the operator to keep the logged in users session alive.
   * Called with an interval of 120 seconds as long as user interacts with the client.
   *
   * @param {Function} $ Reference to jQuery library, loaded internally
   */
  CustomerSettings.prototype.heartbeat = function($) {
    Global.logger.debug('[CustomerSettings] heartbeat', $);
    heartBeatCallback();
  };

  /**
   * Register a callback that is called once with its own callback to be called to keep the client session alive.
   * It will register a custom interaction and in the end of the heartbeat trigger the heartbeat as like any other interaction
   *
   * @param {Function} cb Callback to trigger when interaction happens
   *
   */
  CustomerSettings.prototype.registerKeepAliveCallback = function(cb) {
    // Global.logger().debug("[CustomerSettings] registerKeepAliveCallback", cb(keepAliveCallback()));
    keepAliveCallback(cb);
  };

  /**
   * Inform the operator that the user clicked on event statistics link icon in event page or league view
   *
   * @param {String} eventId Event id (kambi event id)
   * @param {Function} $ Reference to jQuery library, loaded internally
   */
  CustomerSettings.prototype.showEventStatistics = function(eventId, $) {
    Global.logger.debug('[CustomerSettings] showEventStatistics', $);
    showEventStatisticsCallback(eventId);
  };

  let cs = new CustomerSettings();
  return cs;
}
